import type { HelpArticle } from '../../../components/help/types';

export const mdaManagementArticles: HelpArticle[] = [
  {
    id: 'mda-overview',
    title: 'MDA Management Overview',
    summary: 'Managing Ministries, Departments, and Agencies.',
    category: 'mda-management',
    order: 1,
    keywords: ['mda', 'ministry', 'department', 'agency', 'institution', 'management'],
    content: `
# MDA Management Overview

Manage all Ministries, Departments, and Agencies (MDAs) from the central platform.

## What is an MDA?

An MDA is an institutional unit within Ghana's civil service:
- **Ministry**: Government ministries
- **Department**: Government departments
- **Agency**: Specialized agencies

## Key Concepts

### Multi-Tenancy
Each MDA operates in isolation:
- Separate data storage
- Independent user base
- Customizable settings
- Individual branding

### MDA Codes
Unique identifiers for each MDA:
- Used for login routing
- URL subdomain creation
- Data segregation

## Your Responsibilities

As a platform administrator:
- Create and configure MDAs
- Manage MDA administrators
- Monitor MDA activity
- Handle support escalations
- Ensure compliance
    `,
  },
  {
    id: 'mda-create',
    title: 'Creating a New MDA',
    summary: 'How to onboard a new institution to the platform.',
    category: 'mda-management',
    order: 2,
    keywords: ['create', 'new', 'mda', 'onboard', 'setup', 'institution'],
    content: `
# Creating a New MDA

Onboard a new institution to the OHCS platform.

## Before You Start

Gather required information:
- Official institution name
- Short code (e.g., MOF, MOH)
- Primary contact details
- Initial administrator info

## Creation Steps

1. Go to **MDAs** in the platform menu
2. Click **Create New MDA**
3. Fill in the form:
   - Institution name
   - MDA code (unique)
   - Region
   - Contact information
4. Configure initial settings:
   - Default document types
   - Classification levels
   - Branding options
5. Create admin account:
   - Admin email
   - Admin name
   - Temporary password
6. Review and confirm
7. Click **Create MDA**

## After Creation

- Admin receives welcome email
- MDA appears in directory
- Login URL is activated
- Default settings are applied

## Initial Setup Checklist

For the new MDA admin:
- [ ] Change password
- [ ] Set up departments
- [ ] Create roles
- [ ] Add initial users
- [ ] Configure workflows
    `,
  },
];
